<template>
  <el-form
    class="form-step-3"
    ref="form"
    :model="model"
    :rules="rules"
  >
    <el-row
      class="form-step-3__person"
      v-for="(person, i) in clubContactPersons"
      :key="`form-step-3__person--${i}`"
    >
      <app-contact-person-form
        v-model="clubContactPersons[i]"
        :gutter="16"
        :index="i"
        ref="personForm"
        @delete="removePerson(i)"
      />
    </el-row>
    <footer
      v-if="clubContactPersons && clubContactPersons.length < 2"
      class="form-step-3__add-more"
    >
      <el-button
        class="form-step-3__add-more__button"
        type="primary"
        icon="icon-add"
        @click="addPerson"
      >
        <app-i18n
          class="form-step-3__add-more__button__text"
          code="teamRegistrationSite.form.step3.buttons.addMore"
        />
      </el-button>
    </footer>
  </el-form>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

import AppContactPersonForm from '@/components/ContactPersonForm.vue'

import { i18n } from '@shared/i18n'
import { FormSchema } from '@shared/form/form-schema'

import { TeamRegistrationModel } from '@/models/team-registration-model'

import { generateVuexStateComputed } from '@/helpers/generateVuexStateComputed'

const { fields } = TeamRegistrationModel

const formSchema = new FormSchema([
  fields.clubContactPersons,
])

export default {
  name: 'appFormStep3',
  data() {
    return {
      i18n,
      fields,
      rules: formSchema.rules(),
    }
  },
  computed: {
    ...mapGetters('teamRegistration', ['model']),
    clubContactPersons: generateVuexStateComputed('clubContactPersons'),
  },
  async mounted() {
    await this.$nextTick()
    this.setStepValidate()

    if (!this.clubContactPersons || !this.clubContactPersons.length) {
      this.clubContactPersons = [{ phone: {} }]
    } else {
      await this.$nextTick()
      this.$refs.personForm[0].uncollapse()
    }
  },
  methods: {
    ...mapMutations('form', ['setCurrentStepValidate']),
    addPerson() {
      const persons = [...this.clubContactPersons, {}]
      this.clubContactPersons = persons
      this.setStepValidate()
    },
    async removePerson(i) {
      let persons = [...this.clubContactPersons]
      persons.splice(i, 1)
      if (persons.length === 0) {
        persons = [{ phone: {} }]
        this.$refs.personForm[0].isCollapsed = false
      }
      this.clubContactPersons = persons
      this.setStepValidate()
    },
    setStepValidate() {
      this.setCurrentStepValidate(async () => {
        const promises = []

        for (const [i, person] of this.$refs.personForm.entries()) {
          const isEmptyPerson = !this.clubContactPersons[i] || !Object.keys(this.clubContactPersons[i]).length

          if (isEmptyPerson) {
            this.removePerson(i)
          } else {
            promises.push(person.$refs.form.validate())
          }
        }

        await Promise.all(promises)
      })
    },
  },
  components: {
    AppContactPersonForm,
  },
}
</script>

<style lang="scss" scoped>
.form-step-3 {
  text-align: center;

  &__person {
    background-color: #f8f8f8;
    margin-bottom: 8px;
    padding: 0 8px;

    @include tablet {
      margin-bottom: 16px;
      padding: 0 16px;
    }
  }

  &__add-more {
    display: flex;

    &__button {
      flex-grow: 1;
      border-radius: 0 !important;

      &__text {
        margin-left: 8px;
        word-break: break-word;
        white-space: pre-wrap;
        line-height: initial;
        font-size: 12px;

        @include mobile {
          font-size: 14px;
        }
      }
    }
  }
}
</style>
